import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateEntitlementGroupInterface,
  EntitlementGroupInterface,
  UpdateEntitlementGroupInterface
} from '@thro-types/access-handler';

import { createLeihbarAccess, deleteLeihbarAccess, updateLeihbarAccess } from 'api';
import { AxiosRequestConfig } from 'axios';

export const useLeihbarAccessMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();
  const queryKey = ['entitlementGroups'];

  const create = useMutation<EntitlementGroupInterface, Error, CreateEntitlementGroupInterface>({
    mutationFn: async args => {
      return await createLeihbarAccess(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const update = useMutation<
    EntitlementGroupInterface,
    Error,
    { id: number; data: UpdateEntitlementGroupInterface }
  >({
    mutationFn: async args => {
      return await updateLeihbarAccess(args.id, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  const deletion = useMutation<EntitlementGroupInterface, Error, number>({
    mutationFn: async args => {
      return await deleteLeihbarAccess(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { create, update, deletion } as const;
};
